<template>
  <div class="customer_service_question">
    <div class="question_wrap1">
      <span v-if="isShowGoBack" class="goback" @click="goBackRoute">
        &lt; 返回
      </span>
    </div>
    <div class="question_wrap2">
      <div class="question_tabs">
        <router-link
          class="question_tab"
          :class="{ active: tabsActiveList[0] }"
          to="/customer/question/commit"
        >
          我要提问
        </router-link>
        <router-link
          class="question_tab"
          :class="{ active: tabsActiveList[1] }"
          to="/customer/question/history"
        >
          提问记录
        </router-link>
      </div>
      <nuxt-child :history-status-map="historyStatusMap" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      routeHistoryList: [],
      historyStatusMap: {
        0: {
          label: '待解决',
          value: 0,
          alias: 'GM_TO_REPLY',
          style: { background: '#f56c6c', color: '#ffffff' }
        },
        1: {
          label: '处理中',
          value: 1,
          alias: 'GM_PROCESSING',
          style: { background: '#e6a23c', color: '#ffffff' }
        },
        2: {
          label: '处理中',
          value: 2,
          alias: 'GM_PROCESSING',
          style: { background: '#e6a23c', color: '#ffffff' }
        },
        3: {
          label: '处理中',
          value: 3,
          alias: 'GM_PROCESSING',
          style: { background: '#e6a23c', color: '#ffffff' }
        },
        4: {
          label: '处理中',
          value: 4,
          alias: 'GM_PROCESSING',
          style: { background: '#e6a23c', color: '#ffffff' }
        },
        5: {
          label: '处理中',
          value: 5,
          alias: 'GM_PROCESSING',
          style: { background: '#e6a23c', color: '#ffffff' }
        },
        6: {
          label: '新回复',
          value: 6,
          alias: 'GM_REPLY',
          style: { background: '#409eff', color: '#ffffff' }
        },
        7: {
          label: '已撤销',
          value: 7,
          alias: 'USER_CANCEL',
          style: { background: '#a0a0a0', color: '#ffffff' }
        },
        8: {
          label: '已评分',
          value: 8,
          alias: 'USER_GREAD',
          style: { background: '#67c23a', color: '#ffffff' }
        },
        9: {
          label: '已解答',
          value: 9,
          alias: 'USER_LOOK',
          style: { background: '#67c23a', color: '#ffffff' }
        },
        10: {
          label: '已删除',
          value: 10,
          alias: 'GM_CANCEL',
          style: { background: '#a0a0a0', color: '#ffffff' }
        },
        11: {
          label: '重复提问',
          value: 11,
          alias: 'REPEAT',
          style: { background: '#a0a0a0', color: '#ffffff' }
        }
      }
    }
  },
  computed: {
    isShowGoBack() {
      if (
        this.routeHistoryList.length === 1 &&
        /^\/customer\/question\/\d+\/?$/.test(this.routeHistoryList[0])
      ) {
        return true
      } else if (
        /^\/customer\/question\/?$/.test(this.$route.path) ||
        (/^\/customer\/question\//.test(this.$route.path) &&
          !/^\/customer\/question\/\d+\/?$/.test(this.$route.path) &&
          !/^\/customer\/question\/\d+\//.test(this.$route.path))
      ) {
        return true
      } else if (this.routeHistoryList.length > 1) {
        return true
      } else {
        return false
      }
    },
    tabsActiveList() {
      return [
        /^\/customer\/question\/?$/.test(this.$route.path) ||
          /^\/customer\/question\/commit\/?$/.test(this.$route.path) ||
          /^\/customer\/question\/commit\//.test(this.$route.path),
        /^\/customer\/question\/(history|\d+)\/?$/.test(this.$route.path) ||
          /^\/customer\/question\/(history|\d+)\//.test(this.$route.path)
      ]
    }
  },
  mounted() {
    this.routeHistoryList.push(this.$route.path)
    this.$router.beforeEach((to, from, next) => {
      const _historyList = this.routeHistoryList.filter(
        (item) => item !== to.path
      )
      _historyList.push(to.path)
      this.routeHistoryList = _historyList
      next()
    })
  },
  methods: {
    goBackRoute() {
      if (
        this.routeHistoryList.length === 1 &&
        /^\/customer\/question\/\d+\/?$/.test(this.routeHistoryList[0])
      ) {
        this.routeHistoryList = ['/customer/question/history']
        this.$router.push(this.routeHistoryList[0])
      } else if (
        this.routeHistoryList.length === 1 &&
        (/^\/customer\/question\/?$/.test(this.$route.path) ||
          (/^\/customer\/question\//.test(this.$route.path) &&
            !/^\/customer\/question\/\d+\/?$/.test(this.$route.path) &&
            !/^\/customer\/question\/\d+\//.test(this.$route.path)))
      ) {
        this.routeHistoryList = ['/customer']
        this.$router.push(this.routeHistoryList[0])
      } else {
        this.routeHistoryList.pop()
        this.$router.push(
          this.routeHistoryList[this.routeHistoryList.length - 1]
        )
      }
    }
  }
}
</script>
